import { Component, Inject, Input, Output } from '@angular/core';
import { Observable, Subject, forkJoin } from 'rxjs';
import { SubjectRelay } from '../../../../shared/commands/subject-relay.class';

import { UpdateStepDefinitionOrder } from "../../entities/document-pa-update-step-definition-order.entity";
import { ParcTLR } from "../../../structure/parc/entities/parc-tlr.entity";
import { UpdateStepEntrepriseOrder } from "../../entities/document-pa-update-step-entreprise-order.entity";
import { UpdateStepValidationOrder } from "../../entities/document-pa-update-step-validation-order.entity";
import { SignatairePaEntity } from "../../entities/signataire-pa.entity";

import { DocumentPaService } from "../../services/document-pa-service";
import { ParcService } from "../../../structure/parc/services/parc.service";

@Component({
    selector: 'pa-resume',
    templateUrl: 'pa-resume.html',
    styleUrls: ['pa-resume.css'],
})
export class PaResumeComponent {

    displaySubject = new Subject<boolean>();
    @Input() id = 'paResumeDialog';

    documentPa: UpdateStepDefinitionOrder = new UpdateStepDefinitionOrder();
    parcCodes: string[] = [];
    entrepriseData!: UpdateStepEntrepriseOrder;
    updateStepValidationOrder!: UpdateStepValidationOrder;

    private detailCommandsSubject = new SubjectRelay<number>();
    private etatCommandsSubject = new SubjectRelay<string>();

    currentEtat!: string;
	
	etatLabels: { [key: string]: string } = {
	    BROUILLON: 'Brouillon',
	    A_FAIRE_SIGNER: 'À faire signer',
	    ENVOYE_VIA_DOCUSIGN: 'Envoyé via DocuSign',
	    SIGNE_PARTIELLEMENT: 'Signé partiellement',
	    SIGNE: 'Signé',
	    ARCHIVE: 'Archivé',
	    ATTENTE_DE_RELECTURE: 'En attente de relecture',
	    INVALIDE: 'Invalide',
	};

    @Input() set detailCommands(obs: Observable<number> | undefined) {
        this.detailCommandsSubject.registerSource(obs);
    }

    @Input() set etatCommands(obs: Observable<string> | undefined) {
        this.etatCommandsSubject.registerSource(obs);
    }

    constructor(@Inject(DocumentPaService) private documentPaService: DocumentPaService,
        @Inject(ParcService) private parcService: ParcService) {

        this.etatCommandsSubject.subscribe((etat: string) => {
            this.currentEtat = etat;
        });

        this.detailCommandsSubject.subscribe((currentPaId) => {
            if (currentPaId) {

                forkJoin({
                    definition: this.documentPaService.getStepDefinitionData(currentPaId),
                    entreprise: this.documentPaService.getStepEntrepriseData(currentPaId),
                    stepData: this.documentPaService.getValidationData(currentPaId),
                }).subscribe(({ definition, entreprise, stepData }) => {

                    if (!definition) {
                        return;
                    }

                    this.documentPa = definition;
                    this.entrepriseData = entreprise;
                    this.updateStepValidationOrder = stepData;

                    if (this.documentPa.parcIds?.length) {
                        this.loadParcCodes(this.documentPa.parcIds);
                    } else {
                        this.parcCodes = [];
                    }

                    this.displaySubject.next(true);
                });
            }
        });
    }

    loadParcCodes(ids: number[]): void {
        forkJoin(ids.map(id => this.parcService.getParcTLRById(id)))
            .subscribe((parcs: ParcTLR[]) => {
                this.parcCodes = parcs
                    .filter(p => !!p)
                    .map(p => p.code);
            });
    }

    splitDescription(desc?: string): string[] {
        if (!desc) return [];
        return desc.split('\n').map(line => line.trim()).filter(line => line);
    }

    getSignatairesByEntreprise(idEntreprise: number | null): SignatairePaEntity[] {
        if (!idEntreprise || !this.updateStepValidationOrder?.signataires) {
            return [];
        }

        return this.updateStepValidationOrder.signataires.filter(
            s => s.idEntreprise === idEntreprise
        );
    }

    getNomPrenom(signataire: SignatairePaEntity): string {
        return `${signataire.nom} ${signataire.prenom}`;
    }

    onCloseRequested() {
        this.displaySubject.next(false);
    }
}

